import { useCallback } from 'react';
import { gql } from 'apollo-boost';
import { useMutation } from 'shared/apollo';

export const newService = gql`
  mutation newService(
    $name: String!,
    $description: String!,
    $collectionIds: String!,
    $indicatorIds: String!,
  ) {
  newService(
    name: $name,
    description: $description,
    collectionIds: $collectionIds,
    indicatorIds: $indicatorIds,
  ) {
      success
      id
    }
  }
`;

export function useNewService() {
  const { data, isLoading, mutate } = useMutation();
  const run = useCallback((variables, onFinish) => {
    mutate(newService, variables, response => {
      if (typeof onFinish === 'function') {
        onFinish(response.newService.id);
      }
    });
  }, []);
  return { data, isLoading, run };
}
